module.exports = __webpack_public_path__ + "img/location.2a7a453d.png";